import { useState } from "react";
import { Stack, Step, StepLabel, Stepper } from "@mui/material";
import { type ShiftInviteDialogProps } from "../Dialogs";
import { isDefined } from "@clipboard-health/util-ts";
import { ShiftInviteNearbyWorkers } from "../Autocomplete";
import { NearbyWorkerSearchResult } from "../Autocomplete/useGetNearbyWorkers";
import { ShiftInviteDetails } from "../ShiftInviteDetails";
import { ShiftInviteReview } from "../ShiftInviteReview";
import { useShiftInviteContext } from "../Context/shiftInviteContext";

export function ShiftInviteStepper(props: ShiftInviteDialogProps) {
  const { workerType, modalState, initialActiveState = 0, initialSelectedWorker } = props;
  const [activeStep, setActiveStep] = useState(initialActiveState);
  const [selectedWorker, setSelectedWorker] = useState<NearbyWorkerSearchResult | undefined>(
    initialSelectedWorker
  );
  const { isMultiShiftInvitesEnabled, groupedShiftInvite } = useShiftInviteContext();

  return (
    <Stack spacing={4}>
      <Stepper activeStep={activeStep}>
        <Step>
          <StepLabel>
            {isDefined(selectedWorker)
              ? `Inviting ${selectedWorker.fullName}`
              : "Select a Professional"}
          </StepLabel>
        </Step>
        <Step>
          <StepLabel>Confirm Shift Details</StepLabel>
        </Step>
        {isMultiShiftInvitesEnabled && (
          <Step>
            <StepLabel>Review Invites</StepLabel>
          </Step>
        )}
      </Stepper>
      {(activeStep === 0 || !isDefined(selectedWorker)) && (
        <ShiftInviteNearbyWorkers
          selectedWorker={selectedWorker}
          setSelectedWorker={setSelectedWorker}
          workerType={workerType}
          setActiveStep={setActiveStep}
          modalState={modalState}
        ></ShiftInviteNearbyWorkers>
      )}
      {activeStep === 1 && (
        <ShiftInviteDetails
          selectedWorker={selectedWorker}
          setSelectedWorker={setSelectedWorker}
          setActiveStep={setActiveStep}
          shiftInviteDialogProps={props}
        ></ShiftInviteDetails>
      )}
      {isMultiShiftInvitesEnabled && isDefined(groupedShiftInvite) && activeStep === 2 && (
        <ShiftInviteReview
          modalState={modalState}
          workerType={workerType}
          setActiveStep={setActiveStep}
          groupedShiftInvite={groupedShiftInvite}
          selectedWorker={selectedWorker}
        ></ShiftInviteReview>
      )}
    </Stack>
  );
}
